var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { CollaboratorTicket } from '../../modules/Reports/Model';
import { RenderExpiration } from './Expiration';
import { RenderIdaVuelta } from './IdaVuelta';
import { BlockLogo } from './Blocks/BlockLogo';
import { Align, FontSize } from '../../modules/ReceiptLayouts/Model';
import { PrintRefund } from './PrintRefund';
import { BlockUser } from './Blocks/BlockUser';
import { BlockDate } from './Blocks/BlockDate';
import { BlockService } from './Blocks/BlockService';
import { BlockSeparator } from './Blocks/BlockSeparator';
import { BlockCheckins } from './Blocks/BlockCheckins';
import { BlockPayments } from './Blocks/BlockPayments';
import { BlockQR } from './Blocks/BlockQR';
import { BlockTexto } from './Blocks/BlockTexto';
import { BlockSpaces } from './Blocks/BlockSpaces';
import { BlockAditionalInfo } from './Blocks/BlockAditionalInfo';
import { Texto } from './Texto';
import { BlockExtras } from './Blocks/BlockExtras';
import { BlockDataContact } from './Blocks/BlockDataContact';
import { inject, observer } from 'mobx-react';
import { Button, Text, View } from '../../elements';
import { T } from '../../helpers/i18n';
import { PaymentMethod } from '../../Models/TicketPayment';
import { BlockWeb } from './Blocks/BlockWeb';
import { PaymentMethodView } from '../../modules/components/Payments';
import { Card } from 'reactstrap';
import { BlockAfiliate } from './Blocks/BlockAfiliate';
export const TypeAction = {
    Refund: 'refund',
    ShowPay: 'showPay',
    Pay: 'pay',
};
// export const RenderTicket = (props: Props) => {
let RenderTicket = class RenderTicket extends React.Component {
    render() {
        const { ticket, onClick, onPay, index, store } = this.props;
        const item = ticket;
        // console.log('TicketRenderModal - RenderTicket - item: ', item)
        const totalToPay = store.tempDuePaymentsStore.totalToDue;
        console.log('totalToPay: ', totalToPay);
        const errorTotalToPay = item.totalDue && (totalToPay <= 0 || totalToPay > item.totalDue);
        return (React.createElement("div", { style: {
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                // justifyContent: 'center',
                alignItems: 'center',
                /*border: '1px solid black',*/
                borderLeft: index !== 0 ? '1px solid black' : 'none',
                /*marginTop: 50,*/
                backgroundColor: 'white',
                padding: '1rem',
            } },
            item.totalDue && !item.daterefund && !item.refund_id && (React.createElement(Card, { body: true, title: 'Esta venta tiene pendiente un pago' },
                React.createElement(PaymentView, { small: true, handleOnChangePay: onPay, item: ticket }),
                React.createElement(Button, { primary: true, disabled: errorTotalToPay, onClick: () => onClick(TypeAction.Pay) }, T('payDue')))),
            React.createElement(PrintRefund, { ticket: ticket, onPrint: () => window.print(), onRefund: () => onClick(TypeAction.Refund, ticket) }),
            ticket.numberPrinted && React.createElement("p", null, ticket.numberPrinted),
            React.createElement(BlockLogo, { image: item.image, align: Align.Center }),
            item.cartToken ? (React.createElement(BlockWeb, { collaboratorName: item instanceof CollaboratorTicket
                    ? item.collaboratorName
                    : undefined })) : (React.createElement(BlockUser, { user: item.username, collaboratorName: item instanceof CollaboratorTicket
                    ? item.collaboratorName
                    : undefined })),
            React.createElement(BlockDate, { fecha: item.datecheck }),
            React.createElement(BlockSeparator, null),
            ticket.numberSI && (React.createElement(Texto, { texto: 'Factura Simplificada nº', fontSize: FontSize.big })),
            React.createElement("h3", null, ticket.numberSI ? ticket.numberSI : 'RECIBO'),
            React.createElement(BlockSeparator, null),
            React.createElement(BlockDataContact, { ticket: ticket }),
            ticket.contact &&
                (ticket.contact.name !== '' ||
                    ticket.contact.telephone !== '' ||
                    ticket.contact.email !== '') && React.createElement(BlockSeparator, null),
            React.createElement(BlockService, { operationline: item.operationLineName, stretchName: item.stretchName, origin: item.origin, destination: item.destination }),
            React.createElement(BlockSeparator, null),
            React.createElement(BlockCheckins, { lines: item.lines }),
            React.createElement(BlockSeparator, null),
            React.createElement(BlockExtras, { item: item }),
            React.createElement(BlockAfiliate, { item: item }),
            React.createElement(BlockPayments, { item: item }),
            React.createElement(BlockQR, { ticket: item }),
            React.createElement(BlockSpaces, null),
            React.createElement(BlockTexto, { texto: 'Gracias por su visita' }),
            React.createElement(BlockSpaces, null),
            React.createElement(BlockTexto, { texto: '**************************************' }),
            React.createElement(RenderExpiration, { item: item }),
            React.createElement(BlockSpaces, null),
            React.createElement(BlockAditionalInfo, { aditionalInfo: item.aditionalInfo }),
            item.vuelta && !item.hoponHopoff && React.createElement(RenderIdaVuelta, null),
            !item.daterefund && item.datevalited && item.numberScanned === 1 && (React.createElement("img", { style: {}, alt: 'image', width: '90x', src: '/assets/images/valited.jpeg' })),
            !item.daterefund && item.datevalited && item.numberScanned === 2 && (React.createElement("div", null,
                React.createElement("img", { style: {}, alt: 'image', width: '90px', src: '/assets/images/valited.jpeg' }),
                React.createElement("img", { style: {}, alt: 'image', width: '90px', src: '/assets/images/valited.jpeg' }))),
            item.daterefund && (React.createElement("img", { style: {}, alt: 'cancelled', width: '90px', src: '/assets/images/cancelled.png' }))));
    }
};
RenderTicket = __decorate([
    inject('store'),
    observer
], RenderTicket);
export { RenderTicket };
// const PaymentView = (props) => {
let PaymentView = class PaymentView extends React.Component {
    constructor() {
        super(...arguments);
        this.refCash = React.createRef();
        this.refCard = React.createRef();
        // refCredit: React.RefObject<HTMLInputElement> = React.createRef<HTMLInputElement>()
        this.refTransf = React.createRef();
        this.refOther = React.createRef();
        this.handleTouchable = (input) => {
            var _a;
            console.log('input: ', input);
            (_a = input === null || input === void 0 ? void 0 : input.current) === null || _a === void 0 ? void 0 : _a.focus();
        };
        this.onClearInput = (event, ref) => {
            ref.current.value = '';
            // event.currentTarget.value = ''
        };
    }
    render() {
        const { store, item, handleOnChangePay } = this.props;
        store.tempDuePaymentsStore.setTotalDue(item.totalDue);
        const { amountCash, amountCard, amountTransfer, amountOther } = store.tempDuePaymentsStore;
        const errorTotalToPay = store.tempDuePaymentsStore.totalToDue !== item.totalDue;
        const totalToPay = store.tempDuePaymentsStore.totalToDue;
        const message = `El importe a pagar es ${totalToPay > item.totalDue ? 'mayor' : 'menor'} al pendiente de cobro`;
        return (React.createElement(View, null,
            errorTotalToPay && (React.createElement(Text, { center: true, primary: true }, message)),
            React.createElement(View, { flex: true, row: true },
                React.createElement(PaymentMethodView, { small: true, method: PaymentMethod.Cash, enabled: true, title: T(PaymentMethod.Cash), selected: store.tempDuePaymentsStore.amountCash > 0, refInput: this.refCash, value: store.tempDuePaymentsStore.amountCash, moneyName: item.money, onHandleClick: () => { }, onHandleInput: (input, ref) => {
                        handleOnChangePay(PaymentMethod.Cash, input);
                    }, onClearInput: (input, ref) => {
                        ref.current.value = '';
                    }, onHandleAllMoneyClick: () => {
                        store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Cash);
                    } }),
                React.createElement(PaymentMethodView, { small: true, method: PaymentMethod.Card, enabled: true, title: T(PaymentMethod.Card), selected: store.tempDuePaymentsStore.amountCard > 0, refInput: this.refCard, value: store.tempDuePaymentsStore.amountCard, moneyName: item.money, onHandleClick: () => { }, onHandleInput: (input, ref) => {
                        handleOnChangePay(PaymentMethod.Card, input);
                    }, onClearInput: (input, ref) => {
                        ref.current.value = '';
                    }, onHandleAllMoneyClick: () => {
                        store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Card);
                    } }),
                React.createElement(PaymentMethodView, { small: true, method: PaymentMethod.Transfer, enabled: true, title: T(PaymentMethod.Transfer), selected: store.tempDuePaymentsStore.amountTransfer > 0, refInput: this.refTransf, value: store.tempDuePaymentsStore.amountTransfer, moneyName: item.money, onHandleClick: () => { }, onHandleInput: (input, ref) => {
                        handleOnChangePay(PaymentMethod.Transfer, input);
                    }, onClearInput: (input, ref) => {
                        ref.current.value = '';
                    }, onHandleAllMoneyClick: () => {
                        store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Transfer);
                    } }),
                React.createElement(PaymentMethodView, { small: true, method: PaymentMethod.Other, enabled: true, title: T(PaymentMethod.Other), selected: store.tempDuePaymentsStore.amountOther > 0, refInput: this.refOther, value: store.tempDuePaymentsStore.amountOther, moneyName: item.money, onHandleClick: () => { }, onHandleInput: (input, ref) => {
                        handleOnChangePay(PaymentMethod.Other, input);
                    }, onClearInput: (input, ref) => {
                        ref.current.value = '';
                    }, onHandleAllMoneyClick: () => {
                        store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Other);
                    } }))));
    }
};
PaymentView = __decorate([
    inject('store'),
    observer
], PaymentView);



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Ticket.tsx
// module id = 503
// module chunks = 0